import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class LoaderService {
  public isLoading = new BehaviorSubject<boolean>(false);
  public forceDisplay = new BehaviorSubject<boolean>(false);

  constructor() {}

  public forceLoadDisplay(loading: boolean): void {
    this.forceDisplay.next(loading);
  }
}
